import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import type { ConfirmState } from './types';

/**
 * Generic confirm modal used in place of `window.confirm` for destructive
 * actions. Open state is driven by passing/clearing the `state` prop.
 */
const ConfirmDialog = ({
  state,
  onClose,
}: {
  state: ConfirmState | null;
  onClose: () => void;
}) => (
  <Dialog open={!!state} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700, color: '#002A5C' }}>{state?.title}</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {state?.message}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="transparent-text-blue">
        Cancel
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={() => {
          state?.onConfirm();
          onClose();
        }}
      >
        {state?.confirmLabel ?? 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
